// icons
import {
  MdOutlineFactory,
  MdCategory,
  MdInventory2,
  MdInventory,
  MdQrCode,
  MdSwapVert,
  MdWidgets,
  MdPlaylistAddCheck
} from "react-icons/md";

const manufactura = {
  id: 'manufactura-group',
  type: 'group',
  roles: [1, 100, 110],
  breadcrumbs: false,
  children: [
    {
      id: 'manufactura',
      title: 'Manufactura',
      type: 'collapse',
      icon: MdOutlineFactory,
      children: [
        {
          id: 'manufactura-productos',
          title: 'Modelos de productos',
          type: 'item',
          breadcrumbs: false,
          icon: MdCategory,
          url: '/manufactura/productos'
        },
        {
          id: 'manufactura-insumos',
          title: 'Insumos',
          type: 'item',
          breadcrumbs: false,
          icon: MdInventory2,
          url: '/manufactura/insumos'
        },
        {
          id: 'manufactura-existencias',
          title: 'Existencias',
          type: 'collapse',
          icon: MdInventory,
          children: [
            {
              id: 'manufactura-stock',
              title: 'Stock',
              type: 'item',
              breadcrumbs: false,
              icon: MdInventory,
              url: '/manufactura/stock'
            },
            {
              id: 'manufactura-lotes',
              title: 'Lotes',
              type: 'item',
              breadcrumbs: false,
              icon: MdQrCode,
              url: '/manufactura/lotes'
            },
            {
              id: 'manufactura-movimientos-de-stock',
              title: 'Movimientos de stock',
              type: 'item',
              breadcrumbs: false,
              icon: MdSwapVert,
              url: '/manufactura/movimientos-de-stock'
            }
          ]
        },
        {
          id: 'manufactura-insumos-por-producto',
          title: 'Insumos por modelo',
          type: 'item',
          breadcrumbs: false,
          icon: MdWidgets,
          url: '/manufactura/insumos-por-producto'
        },
        {
          id: 'manufactura-insumos-por-orden-de-produccion',
          title: 'Insumos por orden de producción',
          type: 'item',
          breadcrumbs: false,
          icon: MdPlaylistAddCheck,
          url: '/manufactura/insumos-por-orden-de-produccion'
        }
      ]
    }
  ]
};

export default manufactura;
